<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import Breadcrumb from './Breadcrumb.vue';

const route = useRoute();
const router = useRouter();

const SEGMENT_LABELS = {
  dashboard: 'Início',
  conversations: 'Conversas',
  contacts: 'Contatos',
  companies: 'Empresas',
  campaigns: 'Campanhas',
  reports: 'Relatórios',
  settings: 'Configurações',
  inboxes: 'Caixas de entrada',
  agents: 'Agentes',
  teams: 'Equipes',
  labels: 'Marcadores',
  attributes: 'Atributos',
  automations: 'Automações',
  integrations: 'Integrações',
  applications: 'Aplicativos',
  profile: 'Perfil',
  billing: 'Faturamento',
  proposals: 'Propostas',
  contracts: 'Contratos',
  inventory: 'Estoque',
  shop: 'Loja',
  'consulta-lemit': 'Consultas de dados',
  'consultas-dados': 'Consultas de dados',
  calendar: 'Agenda',
  openai: 'OpenAI',
  new: 'Novo cadastro',
  edit: 'Editar',
  create: 'Novo cadastro',
  list: 'Lista',
  index: 'Visão geral',
  'assignment-policy': 'Atribuição de agentes',
  assignment: 'Política de atribuição',
  capacity: 'Capacidade dos agentes',
  campanhas: 'Campanhas',
  'whatsapp-flows': 'WhatsApp Flows',
  'whatsapp-catalogos': 'Catálogos do WhatsApp',
  funil: 'Automações visuais',
  conversation: 'Conversas',
  emails: 'E-mails',
  email: 'E-mail',
  overview: 'Visão geral',
  inboxes_overview: 'Caixas de entrada',
  labels_overview: 'Etiquetas',
  agents_overview: 'Agentes',
  teams_overview: 'Equipes',
  csat: 'CSAT',
  bot: 'Bot',
  ia: 'Consumo de IA',
  sla: 'SLA',
  configuration: 'Configuração',
};

const normalizeLabel = segment => {
  const decoded = decodeURIComponent(segment);
  if (SEGMENT_LABELS[decoded]) return SEGMENT_LABELS[decoded];
  if (/^\d+$/.test(decoded)) return `#${decoded}`;

  return decoded
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, character => character.toUpperCase());
};

const items = computed(() => {
  const segments = route.path.split('/').filter(Boolean);
  const accountIndex = segments.indexOf('accounts');
  const accountId = route.params.accountId;
  const pageSegments =
    accountIndex >= 0 ? segments.slice(accountIndex + 2) : segments.slice(1);

  const crumbs = [
    {
      label: 'Início',
      to: { name: 'home', params: { accountId } },
    },
  ];

  pageSegments.forEach((segment, index) => {
    if (index === 0 && segment === 'dashboard') return;

    const absoluteIndex =
      accountIndex >= 0 ? accountIndex + 2 + index : index + 1;
    crumbs.push({
      label: normalizeLabel(segment),
      to: `/${segments.slice(0, absoluteIndex + 1).join('/')}`,
    });
  });

  return crumbs;
});

const navigate = item => {
  if (item.to) router.push(item.to);
};
</script>

<template>
  <div
    :class="{ hidden: items.length <= 1 }"
    class="flex h-11 shrink-0 items-center border-b border-n-weak bg-n-background px-4 sm:px-5"
    :aria-hidden="items.length <= 1"
  >
    <Breadcrumb :items="items" @click="navigate" />
  </div>
</template>
